import { render, staticRenderFns } from "./DeliveredTotalByEmail.vue?vue&type=template&id=11145702&"
import script from "./DeliveredTotalByEmail.vue?vue&type=script&lang=js&"
export * from "./DeliveredTotalByEmail.vue?vue&type=script&lang=js&"
import style0 from "./DeliveredTotalByEmail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports